import {
    VISIBLE_QUESTIONS_RESET,
    VISIBLE_QUESTIONS_UPDATED,
    RESET_BANKER_QUESTIONNAIRE,
    SET_NON_SENSITIVE_USER_DETAILS,
    REVIEW_BANKER_QUESTIONNAIRE,
    RESET_REVIEW_QUESTIONS,
    NAVIGATE_TO_FIRST_QUESTION,
    RESET_NAVIGATE_TO_FIRST_QUESTION,
    UPDATE_UNSAVED_ANSWERS_ON_SAVE,
    CLEAR_UNSAVED_ANSWERS_ON_DISCARD,
} from '../../constants';

import { UPDATE_APP_PAGE_ANSWERS } from '../../constants/dynamicLanding';
import { createAnswerContainer, getAnswers } from '../../utils';

const initialState = {
    navigateToFirstQuestion: false,
    reviewQuestions: false,
    visibleQuestions: ['P1Q1'],
    answerContainer: {
        P1Q1: {},
    },
    unsavedAnswerContainer: {
        P1Q1: {},
    },
    userDetails: {
        givenName: '',
        familyName: '',
        userId: '',
        email: '',
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case VISIBLE_QUESTIONS_RESET:
            return {
                ...state,
                visibleQuestions: [],
            };
        case RESET_BANKER_QUESTIONNAIRE:
            return {
                ...state,
                visibleQuestions: ['P1Q1'],
                answerContainer: { P1Q1: {} },
                unsavedAnswerContainer: { P1Q1: {} },
            };
        case REVIEW_BANKER_QUESTIONNAIRE: {
            return {
                ...state,
                reviewQuestions: true,
                visibleQuestions: action.payload.visibleQuestions,
            };
        }
        case VISIBLE_QUESTIONS_UPDATED:
            return {
                ...state,
                visibleQuestions: action.action,
                unsavedAnswerContainer: JSON.parse(
                    JSON.stringify(
                        createAnswerContainer(
                            action.action,
                            state.unsavedAnswerContainer,
                        ),
                    ),
                ),
            };
        case UPDATE_APP_PAGE_ANSWERS: {
            return {
                ...state,
                unsavedAnswerContainer: JSON.parse(
                    JSON.stringify(
                        getAnswers(
                            action.questionID,
                            action.answerID,
                            action.visibleQuestions,
                            action.unsavedAnswerContainer,
                        ),
                    ),
                ),
            };
        }
        case SET_NON_SENSITIVE_USER_DETAILS: {
            return {
                ...state,
                userDetails: action.payload,
            };
        }
        case RESET_REVIEW_QUESTIONS: {
            return {
                ...state,
                reviewQuestions: false,
            };
        }
        case NAVIGATE_TO_FIRST_QUESTION: {
            return {
                ...state,
                navigateToFirstQuestion: true,
            };
        }
        case RESET_NAVIGATE_TO_FIRST_QUESTION: {
            return {
                ...state,
                navigateToFirstQuestion: false,
            };
        }
        case UPDATE_UNSAVED_ANSWERS_ON_SAVE:
            return {
                ...state,
                answerContainer: JSON.parse(
                    JSON.stringify(state.unsavedAnswerContainer),
                ),
            };
        case CLEAR_UNSAVED_ANSWERS_ON_DISCARD:
            return {
                ...state,
                unsavedAnswerContainer: JSON.parse(
                    JSON.stringify(state.answerContainer),
                ),
            };
        default:
            return state;
    }
};
